import * as React from 'react';
import {
  SkeletonCircle,
  SkeletonText,
  SkeletonRectangle,
} from '@leagueplatform/genesis-core';
import { TableRow, TableCell } from '../table-pieces.component';

export interface EntityListTableSkeletonRowProps {
  selectable?: boolean;
  columnsLength?: number;
}

export const EntityListTableSkeletonRow = ({
  selectable = false,
  columnsLength,
}: EntityListTableSkeletonRowProps) => (
  <TableRow>
    {selectable && (
      <TableCell css={{ paddingY: 19.5 }}>
        <SkeletonCircle size="$oneAndHalf" />
      </TableCell>
    )}
    {!columnsLength ? (
      <>
        {/* NAME */}
        <TableCell css={{ paddingY: 19.5 }}>
          <SkeletonText />
        </TableCell>
        {/* ID */}
        <TableCell css={{ paddingY: 19.5 }}>
          <SkeletonText />
        </TableCell>
        {/* DATE */}
        <TableCell css={{ paddingY: 19.5 }}>
          <SkeletonText />
        </TableCell>
        {/* STATUS */}
        <TableCell css={{ paddingY: 19.5 }}>
          <SkeletonRectangle css={{ borderRadius: '$pill', height: 20 }} />
        </TableCell>
      </>
    ) : (
      // DYNAMIC COLUMNS ONLY
      <>
        {Array(columnsLength)
          .fill(true)
          .map((_, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <TableCell key={`extra-${idx}`} css={{ paddingY: 19.5 }}>
              <SkeletonText />
            </TableCell>
          ))}
      </>
    )}
  </TableRow>
);
